import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Role } from "@planzone/dto";
import { CoreContext } from "../context";
import { useRetrieveCurrentPlanzone } from "../planzone/retrieveCurrentPlanzone";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  roles: Identifiable<Role>[];
  retrieveRoles(request: Boundaries["retrieveRoles"]["request"]): void;
}

function sortRoles(roles: Identifiable<Role>[]) {
  const order = [
    "pz_admin",
    "pz_under_admin",
    "pz_user",
    "pz_visitor",
    "pr_manager",
    "pr_worker",
    "pr_visitor",
  ];
  const getOrder = (role: Identifiable<Role>) =>
    order.findIndex((key) => key === role.name);

  return [...roles].sort((current, next) =>
    getOrder(current) > getOrder(next) ? 1 : -1,
  );
}

function useRolesRetrieval(): ViewModel {
  const { selector, core } = useContext(CoreContext);
  const { planzone } = useRetrieveCurrentPlanzone();
  const roles = useSelector(() => selector.getRoles(planzone));
  const sortedRoles = sortRoles(roles);

  return {
    isRequestPending: useSelector(() =>
      selector.isRolesRetrievalRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRolesRetrievalRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRolesRetrievalRequestFailure(planzone),
    ),
    roles: sortedRoles,
    retrieveRoles: core.retrieveRoles,
  };
}

export { useRolesRetrieval };
